import React from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';

import CustomHead from './CustomHead';
import CustomBody from './CustomBody';

const DataTable = ({ getTableProps, headerGroups, prepareRow, page, columns }) => (
  <TableContainer style={page.length !== 0 ? { height: '100%' } : {}}>
    <Table stickyHeader aria-label="sticky table" {...getTableProps()}>
      <TableHead>
        <CustomHead headerGroups={headerGroups} />
      </TableHead>
      <TableBody>
        <CustomBody page={page} prepareRow={prepareRow} columns={columns} />
      </TableBody>
    </Table>
  </TableContainer>
);

export default DataTable;
